import { useQuery } from '@apollo/client';
import ErrorPage from '@website/components/utilities/ErrorPage';
import LoadingPage from '@website/components/utilities/LoadingPage';
import { EditTripItineraryItemsDocument } from '@website/types/graphqlOperations';
import React, { useState } from 'react';
import { Alert, Button, Card, Col, Row } from 'react-bootstrap';
import { MdCancel } from 'react-icons/md';
import DeleteItineraryItem from './DeleteItineraryItem';
import ItineraryForm from './ItineraryForm';

/**
 *
 * ItineraryItems
 *
 * Fetch and display list of itinerary items inside a form
 *
 */
export default function ItineraryEditItems({ tripID }: { tripID: string }) {
  const [showAddForm, setShowAddForm] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const { loading, error, data } = useQuery(EditTripItineraryItemsDocument, {
    variables: {
      tripID,
    },
    fetchPolicy: 'cache-and-network',
  });

  const itineraryItems = data?.trip.itinerary.items;

  if (loading) {
    return <LoadingPage />;
  }

  if (error) {
    return <ErrorPage error={error} />;
  }

  function isLastItem(index: number, length: number) {
    return index === length - 1;
  }

  return (
    <>
      {errorMessage && (
        <Row>
          <Col>
            <Alert variant="danger">{errorMessage}</Alert>
          </Col>
        </Row>
      )}
      {itineraryItems &&
        itineraryItems.map((item, index) => (
          <Card key={item.id} className="my-2">
            <Card.Body>
              {isLastItem(index, itineraryItems.length) && (
                <DeleteItineraryItem
                  itineraryItemId={item.id}
                  onError={(message) => setErrorMessage(message)}
                  tripID={tripID}
                />
              )}
              <ItineraryForm
                hostID={data.trip.host.id}
                tripID={tripID}
                itineraryItem={item}
                onChange={() => {}}
              />
            </Card.Body>
          </Card>
        ))}
      {showAddForm ? (
        <Card key="newItineraryItem" className="my-2">
          <Card.Body>
            <Button
              aria-label="Cancel"
              variant="danger"
              className="float-end mb-2 p-0 px-2 pb-1"
              onClick={() => setShowAddForm(false)}
            >
              <MdCancel /> Cancel
            </Button>
            <ItineraryForm
              hostID={data.trip.host.id}
              tripID={tripID}
              itineraryItem={{
                day: itineraryItems ? itineraryItems.length + 1 : 1,
                title: '',
                id: '',
                description: '',
              }}
              onChange={() => {
                setShowAddForm(false);
              }}
            />
          </Card.Body>
        </Card>
      ) : (
        <div className="d-grid gap-2">
          <Button onClick={() => setShowAddForm(true)} className="mt-2">
            + Add day
          </Button>
        </div>
      )}
    </>
  );
}
